<!-- 资源共享 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_file.png"
      class="banner"
    />
    <div class="wrap">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <div class="subNavs">
        <div class="in w1200">
          <div
            :class="{ nav: true, active: item.code == type }"
            v-for="item in subNavs"
            :key="item.code"
            @click="changeTab(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div class="container w1200">
        <div class="preview" @click="preview">点击预览文件</div>
        <div class="title">{{ detail.fileTitle }}</div>
        <div class="time">{{ detail.createTime | handleTime }}</div>
        <div class="rich" v-html="detail.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import { URL } from "@/util/config";
export default {
  components: { breadCrumb },
  data() {
    return {
      routerHistory: [], // 当前所在位置
      subNavs: [
        {
          title: "政策规范",
          en: "POLICY NORM",
          code: "b9fad355966e46a58762b69acea806e1",
          path: "/files/policy",
        },
        {
          title: "价材信息",
          en: "INFORMATION",
          code: "24a9e394dbaa42128ac53cbe64c5d079",
          path: "/files/information",
        },
        {
          title: "指标数据",
          en: "INDEX DATA",
          code: "ac3172e321d64910b7751e4a73e01461",
          path: "/files/standard",
        },
      ],
      type: "",
      detail: {},
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.type = this.$route.query.code || this.subNavs[0].code;

    this.routerHistory = [
      { path: "/", name: "首页" },
      { name: "资源共享", path: "/files/policy" },
      { name: "资源详情" },
    ];
    this.getDetail();
  },
  mounted() {},
  methods: {
    changeTab(item) {
      this.$router.push(item.path);
    },
    async getDetail() {
      let res = await this.$api.getFileInfo({ id: this.$route.params.id });
      if (!res.data) {
        this.$notify.warning({ title: "当前内容已不存在" });
      }
      this.detail = res.data;
    },
    preview() {
      const arr = this.detail.fileUrl.split(".");
      const fileType = arr[arr.length - 1];
      if (this.detail.privateFlag == 0) {
        // 能下载
        window.open(URL + this.detail.fileUrl);
      } else {
        // 只能看
        const officeTypes = ["pptx", "docx", "xlsx"];
        if (officeTypes.includes(fileType)) {
          // office文件预览
          const prefix = "https://view.officeapps.live.com/op/embed.aspx?src=";
          window.open(prefix + URL + this.detail.fileUrl);
        } else if (fileType == "pdf") {
          // pdf预览
          const prefix =
            "http://api.zyzxgc.cn/file/pdfjs/web/viewer.html?file=";
          window.open(prefix + URL + this.detail.fileUrl);
        } else {
          // 其他文件预览
          window.open(URL + this.detail.fileUrl);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    height: 600px;
    object-fit: cover;
    display: block;
  }
  .wrap {
    background-image: url("http://api.zyzxgc.cn/file/static/file_bg.png");
    background-size: cover;
    background-position-x: center;

    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .subNavs {
    text-align: center;
    border-bottom: 1px solid rgb(103 105 105 / 30%);

    .in {
      display: flex;
    }

    .nav {
      flex: 1;
      padding: 10px 0;
      font-size: 20px;
      cursor: pointer;
      border-bottom: 2px solid transparent;

      &:hover {
        color: $theme;
        border-color: $theme;
      }
    }
    .active {
      font-weight: bold;
      color: $theme;
      border-color: $theme;
    }
  }
  .container {
    margin: 40px auto 120px;
  }

  .preview {
    width: fit-content;
    margin-left: auto;
    color: $theme;
    font-size: 18px;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
  .title {
    text-align: center;
    font-size: 30px;
    margin-top: 10px;
  }
  .time {
    color: #9c9b9b;
    margin: 25px 0 40px;
    text-align: center;
  }
}
@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;
    }
    .subNavs {
      .in {
        overflow: auto;

        a {
          white-space: nowrap;
        }
        .nav {
          font-size: 16px;
          padding: 10px;
        }
      }
    }
    .preview {
      font-size: 14px;
    }
    .title {
      font-size: 18px;
    }
    .time {
      margin: 10px 0;
    }
    .content {
      margin: 30px 0;

      .title-box {
        padding: 10px 0;

        .title {
          font-size: 25px;
        }
      }
      .rich {
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
        overflow: auto;
      }
    }
  }
}
</style>
